// extracted by mini-css-extract-plugin
export default {"cls1":"buttonStyles-cls1__c2e0af795f340b284c2b","cls2":"buttonStyles-cls2___538ef1f2babde2ae2d1 buttonStyles-cls1__c2e0af795f340b284c2b"};